<script setup>
  // Component properties
  defineProps({
    title: {
      type: String,
      description: 'The title of page heading section'
    },
    subtitle: {
      type: String,
      description: 'The subtitle of page heading section'
    }
  })
</script>

<template>
  <div class="content">
    <div
      class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center py-2 text-center text-md-start"
    >
      <div v-if="title" class="flex-grow-1 mb-1 mb-md-0">
        <h1 v-if="title" class="h3 fw-bold mb-2 d-flex align-items-center">
          {{ title }}
          <slot name="suffix" class="" />
        </h1>
        <h2 v-if="subtitle" class="h6 fw-medium fw-medium text-muted mb-0">
          {{ subtitle }}
        </h2>
      </div>
      <div v-if="$slots.extra" class="mt-3 mt-md-0 ms-md-3 space-x-2">
        <slot name="extra" />
      </div>
    </div>
  </div>
</template>
